var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 320",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 90H180"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 140H150"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 190H220"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 240H160"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150 40H360            Q370 40 370 50            L350 280            H140            Q120 280 120 260            V70            Q120 40 150 40Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M370 110H450            L500 165            L492 260            H450"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M395 145H450            L475 185            H395Z",
    fill: "currentColor",
    stroke: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 280,
    r: 36
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 280,
    r: 36
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipped);
export default __webpack_public_path__ + "static/media/shipped.8cf5c1cb1ef0c50675d3488c7a5d4361.svg";
export { ForwardRef as ReactComponent };